import React from 'react'
import InnerBanner from './InnerBanner';
import NatureShield from './NatureShield';

const Hillstation = ()=>{
    return(
        <div>
          <InnerBanner />
          <NatureShield />
          

        </div>
    )
}

export default Hillstation;